export enum OrganizationSettingsEvent {
    General = 'OrganizationSettings.GeneralClickedProChip',
    GeneralUpgrade = 'OrganizationSettings.GeneralClickedProChipUpgrade',
    GeneralContact = 'OrganizationSettings.GeneralClickedProChipContact',
    Advanced = 'OrganizationSettings.AdvancedClickedProChip',
    AdvancedUpgrade = 'OrganizationSettings.AdvancedClickedProChipUpgrade',
    AdvancedContact = 'OrganizationSettings.AdvancedClickedProChipContact',
}
